module.exports = __webpack_public_path__ + "static/media/18ECA6.4adaf498.jpg";